import { classList, getColumnSpan } from '@/helpers';
import { AllShiftsContainer } from '@/components/agent/my-schedule/AllShiftsContainer';
import React, { useCallback } from 'react';
import styled from 'styled-components';

import type { ISortedShift } from '@/types/schedule';
import type { IWeek, IWeekDay } from '@/types/calendar';

import { MIN_WIDTH_SHIFT, PADDING_WEEKDAY, Z_INDEX_CURRENT_TIME_INDICATOR } from '@/config/variables';

interface IProps {
  column: ISortedShift[];
  day: IWeekDay;
  week: IWeek;
  rowTop: number;
  index: number;
  row: ISortedShift[][];
  hasActiveModal: boolean;
}

const ShiftColumn = ({ column, week, day, rowTop, row, index, hasActiveModal }: IProps): React.ReactElement => {
  const colSpan = useCallback(item => getColumnSpan(item, index, row), [index, row]);

  return (
    <Column key={column[0].itemData.id} className={classList(hasActiveModal && 'has-active-modal')}>
      {column
        .filter(item => item.dayNumber === day.dayNumber && item.monthNumber === day.monthNumber)
        .map(item => {
          return (
            <AllShiftsContainer
              shift={item}
              rowTop={rowTop}
              colSpan={colSpan(item)}
              key={item.itemData.id + item.displayBlocks.startBlock}
              day={day}
              week={week}
            />
          );
        })}
    </Column>
  );
};

const MemoizedShiftColumn = React.memo(ShiftColumn);
export { MemoizedShiftColumn as ShiftColumn };

const Column = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  position: relative;

  &.has-active-modal {
    z-index: ${Z_INDEX_CURRENT_TIME_INDICATOR + 1};
  }

  /* TODO: make sure if can be removed permanently -
    - no matter the amount of columns within a single row */
  /* min-width: ${PADDING_WEEKDAY + MIN_WIDTH_SHIFT}px; */
`;
